export const REMEMBERED_LOGIN_STORAGE_KEY = 'bpm-remember-login';

const normalizeLogin = (value) =>
  typeof value === 'string' ? value.trim() : '';

export const clearRememberedLogin = (storage) => {
  if (!storage) return;

  try {
    storage.removeItem(REMEMBERED_LOGIN_STORAGE_KEY);
  } catch {
    // Storage may be unavailable or blocked by the browser.
  }
};

export const storeRememberedLogin = (storage, login) => {
  if (!storage) return;

  const normalizedLogin = normalizeLogin(login);
  if (!normalizedLogin) {
    clearRememberedLogin(storage);
    return;
  }

  try {
    storage.setItem(
      REMEMBERED_LOGIN_STORAGE_KEY,
      JSON.stringify({ login: normalizedLogin })
    );
  } catch {
    // Storage may be unavailable or blocked by the browser.
  }
};

export const readRememberedLogin = (storage) => {
  if (!storage) return '';

  let storedValue;
  try {
    storedValue = storage.getItem(REMEMBERED_LOGIN_STORAGE_KEY);
  } catch {
    return '';
  }

  if (!storedValue) return '';

  try {
    const parsed = JSON.parse(storedValue);
    const login = normalizeLogin(parsed?.login || parsed?.email);

    if (!login) {
      clearRememberedLogin(storage);
      return '';
    }

    // Rewrites the old { login, password } shape without the plaintext password.
    storeRememberedLogin(storage, login);
    return login;
  } catch {
    clearRememberedLogin(storage);
    return '';
  }
};
